import { ArrowUpRight } from "lucide-react";
import { MAPS_URL } from "../../data/site";
import { Reveal, SectionMark } from "./Reveal";

export const Trust = () => (
    <section
        data-testid="trust-section"
        className="relative border-t border-white/[0.07] px-5 py-28 text-center md:py-40"
    >
        <Reveal>
            <SectionMark>( 08 — Povjerenje )</SectionMark>
        </Reveal>

        <Reveal delay={0.1}>
            <p className="mt-12 font-display text-[8rem] font-light italic leading-none text-bronze/30 md:text-[14rem]">
                &ldquo;
            </p>
        </Reveal>

        <Reveal delay={0.15}>
            <p
                data-testid="google-rating-value"
                className="font-display text-7xl font-light tracking-tight text-bone md:text-9xl"
            >
                4.8 <span className="text-3xl text-silver md:text-5xl">/ 5</span>
            </p>
        </Reveal>

        <Reveal delay={0.22}>
            <p className="mt-6 text-[11px] font-medium uppercase tracking-[0.4em] text-silver">
                44 Google recenzije
            </p>
        </Reveal>

        <Reveal delay={0.28}>
            <p className="mx-auto mt-8 max-w-md text-sm leading-relaxed text-silver">
                Stvarne recenzije naših klijenata objavljujemo ovdje uskoro —
                dotad nas provjerite na Googleu.
            </p>
        </Reveal>

        <Reveal delay={0.34}>
            <a
                href={MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="trust-google-link"
                className="mt-10 inline-flex items-center gap-2 border border-bone/25 px-8 py-3.5 text-[11px] font-semibold tracking-[0.26em] text-bone transition-colors duration-300 hover:border-bone hover:bg-bone hover:text-[#0a0a0b]"
            >
                PROVJERI RECENZIJE
                <ArrowUpRight size={14} strokeWidth={1.5} />
            </a>
        </Reveal>
    </section>
);
